export default class extends HTMLElement {

  static get observedAttributes() {
    return ['settings'];
  }

  constructor() {
    super();
    console.log('Init DSBCatchup');
    this.modal_id = this._createUUID();
    console.log('this.modal_id='+this.modal_id);
    //window.dispatchEvent(new CustomEvent('dsb-pwa-add_modal', {detail: {id:this.modal_id}}));
    //window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {tray_id: this.modal_id}}));
  }

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }

  get settings() {
      if(!this._settings)
      {
          if(typeof this.getAttribute('settings') === 'object' && this.getAttribute('settings') !== null)
          {
              this._settings = this.getAttribute('settings');
          }
          else
          {
            this._settings = JSON.parse(``+this.getAttribute('settings')+``);
          }

          if(this._settings == null)
          {
              this._settings = {};
          }
      }
      return this._settings;
  }

  set settings(newValue){
      if(typeof newValue === 'object' && newValue !== null)
      {
        this._settings = newValue;
      }
      else
      {
          this.setAttribute('settings', newValue);
      }
  }

  get query() {
      return this.getAttribute('query');
  }

  set query(newValue){
      this.setAttribute('query', newValue);
  }

  get root_path() {
      return this.getAttribute('root_path');
  }

  set root_path(newValue){
      this.setAttribute('root_path', newValue);
  }

  get title() {
      return this.getAttribute('title');
  }

  set title(newValue){
      this.setAttribute('title', newValue);
  }

  get type() {
      return this.getAttribute('type');
  }

  set type(newValue){
      this.setAttribute('type', newValue);
  }

  nextPage()
  {
    console.error('Next page action fired...');
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


  connectedCallback() {
    return this._render();
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    if(`settings` == name && oldValue != null)
    {
      console.log('dsb-list::attributeChangedCallback: '+name,oldValue,newValue);
      this._settings = null;
      return this._render();
    }
  }

  async _render()
  {
    try
    {
      let _this = this;
      let json = await this.dsbClient.content.get(this.service,"?"+this.query);
      if (json.state) {
        // Some API data found, but *could* be 404 - 0 results!
        let html,template,format  = ``;

        //window.dispatchEvent(new CustomEvent('dsb-pwa-base_update', {detail: {appname: (this.title!=null && this.title.length>0?this.title:'List'), title: ''}}));

        this.classList.add('list-view');
        let list = document.createElement("ul");
        let default_image = '../images/default-image.svg';
        if(_this.dsbClient.content.app_path)
        {
            default_image = _this.dsbClient.content.app_path+'/images/default-image.svg';
        }

        let missing_image = '../images/fwi-logo-grey.svg';
        if(_this.dsbClient.content.app_path)
        {
            missing_image = _this.dsbClient.content.app_path+'/images/fwi-logo-grey.svg';
        }

        var functon_imageExists = function(url, callback) {
            var img = new Image();
            img.onload = function() { callback(true,url); };
            img.onerror = function() { callback(false,url); };
            img.src = url;
        }
        var imageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var image = entry.target;
                functon_imageExists(image.dataset.img,function(exists,img){
                    if(exists)
                    {
                        image.setAttribute('style', 'background-image:url('+img+')');
                    }
                    else
                    {
                        image.setAttribute('style', 'background-image:url('+missing_image+');background-size: auto;');
                    }
                    imageObserver.unobserve(image);
                });

            }
          });
        });


        for(let i = 0; i < json.data.length; i++)
        {
          let current_data = json.data[i];
          if(typeof current_data === 'object' && 'type' in current_data)
          {
            let item_settings = {};
            for(let aSetting in this.settings)
            {
                if(aSetting != `item`)
                {
                    item_settings[aSetting] = this.settings[aSetting];
                }
            }

            if(`item` in this.settings && ( i in this.settings.item))
            {
                for(let aSetting in this.settings.item[i])
                {
                    item_settings[aSetting] = this.settings.item[i][aSetting];
                }
            }


            switch(current_data.type)
            {
                default:
                        let item = document.createElement("li");
                        item.classList.add('item');
                        let grid_size = 0;

                        if(`layout-grid` in item_settings)
                        {
                            grid_size = item_settings[`layout-grid`];
                            switch(grid_size)
                            {
                                case "2":
                                        item.classList.add('layout-grid-2');
                                        break;
                                case "3":
                                        item.classList.add('layout-grid-3');
                                        break;
                                case "4":
                                        item.classList.add('layout-grid-4');
                                        break;
                                case "5":
                                        item.classList.add('layout-grid-5');
                                        break;
                                case "6":
                                        item.classList.add('layout-grid-6');
                                        break;

                                default:
                                    break;
                            }

                        }

                        switch(current_data.type)
                        {
                          case "collection":
                                item.onclick = function(){
                                  let component = document.createElement("dsb-reader");
                                  component.setDSBClient(_this.dsbClient);
                                  component.setAttribute(`service`, `post`);
                                  component.setAttribute('collection_id', current_data.id);
                                  component.innerHTML = `<maa-spinner></maa-spinner>`;
                                  //window.dispatchEvent(new CustomEvent('dsb-pwa-trigger_modal', {detail: {id:_this.modal_id,append:component}}));
                                  window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component}}));
                                }
                                break;
                          default:
                                item.onclick = function(){
                                    let component = document.createElement("dsb-post");
                                    component.setDSBClient(_this.dsbClient);
                                    component.setAttribute(`service`, 'post');
                                    component.setAttribute('post_id', current_data.id);
                                    component.innerHTML = `<maa-spinner></maa-spinner>`;
                                    //window.dispatchEvent(new CustomEvent('dsb-pwa-trigger_modal', {detail: {id:_this.modal_id,append:component}}));
                                    window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component}}));
                                    //window.location.hash = "/single/post/"+current_data.type+"/"+current_data.id;
                                    return;
                                };
                                break;
                        }


                        if('author' in current_data)
                        {
                          if('type' in current_data.author)
                          {
                            switch(current_data.author.type)
                            {
                              case "advert":
                                  item.classList.add('author-advert');
                                  break;
                              default:
                                  break
                            }
                          }
                        }

                        if(`show-thumbnail` in item_settings)
                        {

                            let item_image = document.createElement("span");
                            item_image.classList.add('thumbnail');
                            let attach_to_item = false;
                            let image_size = "medium";
                            let _post_image = default_image;
                            switch(item_settings['show-thumbnail'])
                            {
                                case "right":
                                    item.classList.add(`layout-image-right`);
                                    break;
                                case "top":
                                    item.classList.add(`layout-image-top`);
                                    image_size = "medium";
                                    if(grid_size && grid_size<5)
                                    {
                                        image_size = "large";
                                    }
                                    break;
                                case "left":
                                    item.classList.add(`layout-image-left`);
                                    break;
                                case "bottom":
                                    item.classList.add(`layout-image-bottom`);
                                    image_size = "medium";
                                    if(grid_size && grid_size<5)
                                    {
                                        image_size = "large";
                                    }
                                    break;
                                case "background":
                                    item.classList.add(`layout-image-background`);
                                    image_size = "large";
                                    attach_to_item=true;
                                    break;
                                default:
                                    break;

                            }

                            if('images' in current_data)
                            {
                              if(image_size in current_data.images)
                              {
                                  _post_image = current_data.images[image_size];
                              }
                            }

                            if(!attach_to_item)
                            {
                                item_image.setAttribute('data-img', _post_image);
                                imageObserver.observe(item_image);
                            }
                            else
                            {
                                item.setAttribute('data-img', _post_image);
                                imageObserver.observe(item);
                            }
                            item.append(item_image);

                        }

                        let item_title = document.createElement("h2");
                        if('title' in current_data)
                        {
                          item_title.innerHTML = current_data.title;
                          item.append(item_title);
                        }
                        else
                        {
                          console.error('Unknown title');
                        }


                        if(`show-excerpt` in item_settings && (item_settings[`show-excerpt`] == "true"))
                        {
                            if('excerpt' in current_data)
                            {
                                let item_excerpt = document.createElement("p");
                                item_excerpt.innerHTML = current_data.excerpt;
                                item.append(item_excerpt);
                            }
                        }

                        if('taxonomies' in current_data)
                        {
                          if('category' in current_data.taxonomies)
                          {
                            if(`show_all-categories` in item_settings)
                            {
                                if('list' in current_data.taxonomies.category)
                                {
                                    let item_metadata = document.createElement("ul");
                                    for(let ii = 0; ii < current_data.taxonomies.category.list.length; ii++)
                                    {
                                        let item_metadata_li = document.createElement("li");
                                        item_metadata_li.innerHTML = await this.dsbClient.content.applyFilter(`formatData_lookup`, [ `primary_cat_slug`, current_data.taxonomies.category.list[ii] ] );
                                        item_metadata.append(item_metadata_li);
                                    }
                                    item.append(item_metadata);
                                }
                            }
                            else
                            {
                                if('primary_id' in current_data.taxonomies.category)
                                {
                                    let item_metadata = document.createElement("ul");
                                    let item_metadata_li = document.createElement("li");
                                    let this_tax = await this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, current_data.taxonomies.category.primary_id ]);
                                    if(typeof this_tax === 'object' && `root_parent` in this_tax)
                                    {
                                      this_tax = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, this_tax.root_parent ]);
                                    }
                                    item_metadata_li.innerHTML = this_tax.name;
                                    item_metadata.append(item_metadata_li);
                                    item.append(item_metadata);
                                    item_metadata.classList.add(this_tax.slug+'-category-font-col');
                                }
                            }
                          }
                        }

                        list.append(item);


                        /**
                        //div class="" style="cursor:pointer;" onclick="pwa.route(this);" data-service="`+this.service+`" data-id="{{id}}" data-type="{{type}}">
                        template = `{{#data}}
                        <div class="" style="cursor:pointer;" onclick="location.hash='#/`+this.root_path+`/`+this.service+`/{{type}}/{{id}}'">
                            <div style="display:table">
                                <div style="display:table-row">
                                    <div style="display: table-cell;width:94px;padding-right:15px;">
                                        <div style="width:94px;min-height: 70px;background-image:url('{{image}}');background-size: 100%;background-repeat: no-repeat;" alt="{{title}}"></div>
                                    </div>
                                    <div style="display: table-cell;vertical-align:top;">
                                        <span style="color: #4a4a4a;font-size: 14px;line-height: 20px;font-weight: 500;">{{title}}</span>
                                        <p style="font-family: Roboto;margin-top: 1px;color: #6c6c6c;font-size: 12px;display: block;overflow: hidden;text-overflow: ellipsis;white-space: normal;line-height: 20px;">{{extract}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {{/data}}`;
                        this.innerHTML = this.dsbClient.content.format(json.data, JSON.parse(`{"x":{"fields":[{"key":"id","label":"id"},{"key":"title","label":"title"},{"key":"type","label":"type"},{"key":"url","label":"url"},{"key":"images.medium","label":"image"}]},"y":{"show":false},"caption":"","sort":{"rows":{"column":"","order":"asc","type":"string"}}}`) , `mustache`, template);
                        return;
                        */
              }
          }
          else
          {
            throw 'Missing type in json.data';
          }
        }
        this.innerHTML = '';
        if(`infinate_scroll` in this.settings)
        {
            var scrollObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                console.error('Ok end of page');
                }
            });
            });
            let item_loader = document.createElement("li");
            item_loader.classList.add('item');
            item_loader.innerHTML = "<maa-spinner/>";
            scrollObserver.observe(item_loader);
            list.append(item_loader);
        }
        this.append(list);
      }
      else
      {
        throw json.state;
      }
    }
    catch(ex)
    {
      console.error('dsb-list:: Error',ex);
      this.innerHTML = `
          <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                <article class="error-500" role="article">
                  <p>Sorry an error has occured.</p>
                  <p>Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.</p>
                </article>
            </div>`;
      return;
    }
  }
}


